import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { change, submit, isSubmitting } from "redux-form";
import { showNotification, Button } from "react-admin";
import IconCancel from "@material-ui/icons/Cancel";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Info from "@material-ui/icons/Info";
import ListBikeHistory from "./listBikeHistory";
import styled from "styled-components";

const StyledInfo = styled(Info)`
  height: 18px !important;
`;

class BikeInformationButton extends Component {
  handleDateChange = element => {
    this.setState({ retirementDate: element.target.value });
  };

  state = {
    error: false,
    showDialog: false,
    retirementDate: Date.now()
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false });
  };

  render() {
    const { showDialog } = this.state;

    return (
      <Fragment>
        <StyledInfo
          titleAccess="Vehicle Information"
          onClick={this.handleClick}
          cursor="pointer"
        />
        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={showDialog}
          onClose={this.handleCloseClick}
          aria-label="Vehicle Information"
        >
          <DialogTitle>
            Vehicle Information ({this.props.vehicle.model.model_name} -{" "}
            {this.props.vehicle.licence_plate} {this.props.vehicle.renting ? "®" : "" }) 
          </DialogTitle>
          <DialogContent>
            <ListBikeHistory vehicleId={this.props.vehicle.id} />
          </DialogContent>
          <DialogActions>
            <Button label="ra.action.cancel" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isSubmitting: isSubmitting("post-quick-create")(state)
});

const mapDispatchToProps = {
  change,
  showNotification,
  submit
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BikeInformationButton);



// WEBPACK FOOTER //
// ./src/components/bikeInformation.js